import { render, staticRenderFns } from "./CornersAndGoalsPerMinute.vue?vue&type=template&id=3a102aba&scoped=true&"
import script from "./CornersAndGoalsPerMinute.vue?vue&type=script&lang=js&"
export * from "./CornersAndGoalsPerMinute.vue?vue&type=script&lang=js&"
import style0 from "./CornersAndGoalsPerMinute.vue?vue&type=style&index=0&id=3a102aba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a102aba",
  null
  
)

export default component.exports